import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

import * as hooks from './hooks';

export const EvolutionGames = ({ config }) => {
    const {
        depositPage,
        responsibleGamingPage,
        lobbyPage
    } = config;

    hooks.useRedirectHandler({ depositPage, responsibleGamingPage, lobbyPage });
    hooks.useGameLifecycleSubscription();
    hooks.useTableIdChangeHandler();

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.evolutionGames]: EvolutionGames });
